export const getHrefLangURL = (lang: string) => {
	const localePath = useLocalePath()
	const route = useRoute()

	if (route.name?.includes('news-newsID-newsTitle') || route.name?.includes('car-rental-urlSlug')) {
		return useRequestURL().href
	} else if (route.name === 'index') {
		return !lang || lang === 'pl' ? useRequestURL().origin : `${useRequestURL().origin}/${lang}`
	} else {
		return useRequestURL().origin + localePath(route.name?.slice(0, -5), lang)
	}
}
